// Board identity, default lane set and sort options
export const BOARD_FORMAT = 'componentboard_data';
export const BOARD_TARGET_PICK = 'pick';
export const BOARD_STATE_ACTIVE = 0;
export const BOARD_STATE_COMPLETED = 1;
export const BOARD_ITEM_LIMIT = 500;
export const DEFAULT_STAGE = 'Idea';
export const DONE_STAGE = 'Done';
export const CURRENT_STATE_CAT = 'CurrentState';

// Fixed fields of a new Board-note, title/service/body come from BoardNewDlg
export const NEW_BOARD = { format: BOARD_FORMAT, type: 'Config', cat: 'Board', stateId: BOARD_STATE_ACTIVE };

// Lane = { id, label, match: [rule], dropStage?, enabled?, unmatched? } — rule = { type?, cat?, stage? } (arrays)
// Completed/stage Done always goes to the Done lane, unmatched lane collects everything else without a lane
export const DEFAULT_BOARD_LANES = [
    { id: 'backlog', label: 'Backlog', match: [{ type: ['Issue'], stage: ['Idea', 'Research'] }], dropStage: 'Idea' },
    { id: 'progress', label: 'InProgress', match: [{ type: ['Issue'], stage: ['InProgress'] }], dropStage: 'InProgress' },
    { id: 'done', label: 'Done', match: [{ type: ['Issue'], stage: ['Done'] }], dropStage: 'Done' },
    { id: 'issues', label: 'Issues', match: [{ type: ['Issue'], stage: ['OnHold', 'Decided'] }], dropStage: 'OnHold' },
    { id: 'knowledge', label: 'State & Knowledge', match: [{ cat: ['CurrentState'] }, { cat: ['FeatureSpec'] }, { cat: ['Concept'] }, { type: ['Decision'] }, { cat: ['Knowledge'] }] },
    { id: 'unmatched', label: 'Unmatched', unmatched: true },
];

// Old body format (lanes: string[] + hidden) → lane objects, only used by BoardFetcher
export const LEGACY_LANES = {
    Idea: { id: 'Idea', label: 'Idea', match: [{ type: ['Issue'], stage: ['Idea'] }], dropStage: 'Idea' },
    Research: { id: 'Research', label: 'Research', match: [{ type: ['Issue'], stage: ['Research'] }], dropStage: 'Research' },
    InProgress: { id: 'InProgress', label: 'InProgress', match: [{ type: ['Issue'], stage: ['InProgress'] }], dropStage: 'InProgress' },
    Done: { id: 'Done', label: 'Done', match: [{ type: ['Issue'], stage: ['Done'] }], dropStage: 'Done' },
    CurrentState: { id: 'CurrentState', label: 'Current State', match: [{ cat: ['CurrentState'] }] },
    Concepts: { id: 'Concepts', label: 'Concepts', match: [{ cat: ['Concept'] }] },
    Decisions: { id: 'Decisions', label: 'Decisions', match: [{ type: ['Decision'] }] },
    Knowledge: { id: 'Knowledge', label: 'Knowledge', match: [{ cat: ['Knowledge'] }] },
};

export const SORTS = {
    stage: [
        { key: 'ems', label: 'Created' },
        { key: 'prioId', label: 'Prio' },
        { key: 'importanceId', label: 'Imp' },
    ],
    view: [{ key: 'ems', label: 'Created' }],
};

export const CAT_FILTERS = ['All', 'Feature', 'Bug', 'NiceToHave'];

// Quick-add defaults — cat follows the active filter, Feature when filter is All
export const DEFAULT_ISSUE_CAT = 'Feature';
export const DEFAULT_ISSUE_PRIO = 500;
export const ISSUE_BODY_TEMPLATE = '## Probleem\n\n## Gewenst\n\n## Refs\n';
export const STAGE_OPTIONS = ['Idea', 'Research', 'InProgress', 'OnHold', 'Done'];
export const DRAG_MIME = 'text/plain';

// Lane filter matches rk from this many chars, dashes ignored
export const RK_FILTER_MIN = 8;
